import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserHint, THintName } from "./userHints.t";

export interface IUserHintsState {
    buySellHintShown: boolean,
    demoLimitsHintShown: boolean,
    error: unknown,
    isLoading: boolean,
    shouldTriggerBuySellOrderProtection: boolean,
    userHints: IUserHint[],
}

const initialState: IUserHintsState = {
    buySellHintShown: false,
    demoLimitsHintShown: false,
    error: null,
    isLoading: true,
    userHints: [],
    shouldTriggerBuySellOrderProtection: false,
}

export const userHintsSlice = createSlice({
    name: 'userHints',
    initialState,
    reducers: {
        initUserHintsAction(state, action: PayloadAction) {},
        loadUserHintsSuccess(state, action: PayloadAction<IUserHint[]>) {
            state.userHints = action.payload;
            state.isLoading = false;
        },
        loadUserHintsErrorAction(state, action: PayloadAction<unknown>) {
            state.error = action.payload;
        },
        initAddUserHintAction(state, action: PayloadAction<THintName>) {},
        loadAddUserHintSuccess(state, action: PayloadAction<IUserHint>) {
            state.userHints = [...state.userHints, action.payload];
        },
        setDemoLimitsHintShownAction(state, action: PayloadAction<boolean>) {
            state.demoLimitsHintShown = action.payload;
        },
        setBuySellHintShownAction(state, action: PayloadAction<boolean>) {
            state.buySellHintShown = action.payload;
        },
        setShouldTriggerBuySellOrderProtectionAction(state, action: PayloadAction<boolean>) {
            state.shouldTriggerBuySellOrderProtection = action.payload;
        },
    },
});

export default userHintsSlice.reducer;
